import { toDateKey, formatDisplayDate, offsetDate } from '../utils/dateUtils';

export default function DayNav({ dateKey, setDateKey, daysWithBites }) {
  const today = toDateKey(new Date());
  const isToday = dateKey === today;

  return (
    <div className="day-nav">
      <button
        className="nav-btn"
        onClick={() => setDateKey((k) => offsetDate(k, -1))}
        title="Jour précédent"
      >
        ‹
      </button>

      <div className="day-label">
        <span className="day-text">{formatDisplayDate(dateKey)}</span>
        {!isToday && (
          <button
            className="btn-today"
            onClick={() => setDateKey(today)}
            title="Aller à aujourd'hui"
          >
            Aujourd'hui
          </button>
        )}
      </div>

      <button
        className="nav-btn"
        onClick={() => setDateKey((k) => offsetDate(k, 1))}
        disabled={isToday}
        title="Jour suivant"
      >
        ›
      </button>
    </div>
  );
}
